const SWAGGY_STORERONT_URL = '/apps/proxy/storefront'
const SHOPIFY_DISCOUNT_COOKIE_KEY = 'discount_code'
const CART_ICON_BUBBLE_SELECTOR = '#cart-icon-bubble'
const CUSTOMIZE_PRODUCT_BUTTON_SELECTOR = 'button#pfCustomizeProductBtn.btn.button'
const PRODUCT_FORM_SUBMIT_BUTTON_SELECTOR = '.product-form__submit'
const REGULAR_PRICE_SELECTOR = 'span.price-item--regular'
const SWAGGY_NOTIFICATION_DIV_SELECTOR = '#swaggy-notification'
const SWAGGY_HEADER_LOGO_SELECTOR = '#swaggy-header-logo'
const SWAGGY_METADATA_SELECTOR = '#swaggy-metadata'
const SWAGGY_DISCOUNTED_PRICE_SELECTOR = 'p.swaggy-discounted-price'
const PRODUCT_FORM_BUTTONS_SELECTOR = '.product-form__buttons'
const SWAGGY_CREATE_CODE_BUTTON_SELECTOR = '.swaggy-create-code-button'
const SWAGGY_CREATE_CODE_URL = '/apps/proxy/code'
const SWAGGY_NOT_AUTHORIZED_PAGE = '/pages/not-authorized'
const SWAGGY_HIDDEN_PRICE_SELECTOR = '.swaggy-hidden-price'
const SWAGGY_HIDDEN_PRODUCT_SELECTOR = '.swaggy-hidden-product'
const SWAGGY_HIDDEN_DESCRIPTION_SELECTOR = '.swaggy-hidden-description'
const SWAGGY_STORE_FEEDBACK_BUTTON_SELECTOR = '.swaggy-store-feedback-button'
const SWAGGY_PRODUCT_FEEDBACK_BUTTON_SELECTOR = '.swaggy-product-feedback-button'
const SWAGGY_GIFT_USE_CASE = 'GIFT'
const SWAGGY_HIDE_CLASSES = ["s-opacity-0"]
const SWAGGY_SHOW_CLASSES = ["s-opacity-100"]


function wait(n) {
    console.log(`wait ${n}`)
    return new Promise((resolve) => setTimeout(resolve, n))
}

async function lookupCode(code) {
    // console.log('lookupCode', code)
    const response = await fetch(`${SWAGGY_STORERONT_URL}/codes/${code}`)
    // console.log({response})
    if (!response.ok) {
        throw Error(`error with code ${code}`)
    }
    return response.json()
}

async function getCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js')
    if (!response.ok) {
        throw Error('could not retrieve cart')
    }
    return response.json()
}

async function getRemainingGiftCodeValue(giftCard, cart) {
    const originalValue = getOriginalGiftCardValue(giftCard)
    const valueType = giftCard.valueType
    let discountableCartValue = 0
    // cart items to which the discount can be applied
    cart.items.forEach((item) => {
        // console.log({item})
        item.discounts.forEach((discount) => {
            if (giftCard.title === discount.title) {
                discountableCartValue += discount.amount
            }
        })
    })
    const isPercentageCouponApplied = valueType === 'PERCENTAGE' && discountableCartValue > 0
    return isPercentageCouponApplied ? 0 : originalValue - discountableCartValue / 100
}

function getOriginalGiftCardValue(giftCard) {
    return Math.abs(+giftCard.value)
}

function showNotification(message) {
    console.log("showNotification")
    const $notifyDiv = $(SWAGGY_NOTIFICATION_DIV_SELECTOR)
    const $headerLogo = $(SWAGGY_HEADER_LOGO_SELECTOR)
    $headerLogo.addClass('s-mt-20')
    const $paragraph = $(`<p>${message}</p>`)
    $notifyDiv.html($paragraph)
}

function removeNotification() {
    console.log("removeNotification")
    const $notifyDiv = $(SWAGGY_NOTIFICATION_DIV_SELECTOR)
    const $headerLogo = $(SWAGGY_HEADER_LOGO_SELECTOR)
    $notifyDiv.empty()
    $headerLogo.removeClass('s-mt-20')
}

function currencyDisplay(value) {
    return Number.isInteger(value) ? `$${value}` : `$${value.toFixed(2)}`
}

async function handleGiftCode(code, cart) {
    console.log('handleGiftCode', {code, cart})
    const swaggyCollectionHandle = $(SWAGGY_METADATA_SELECTOR).data('collection-handle')

    try {
        const giftCode = await lookupCode(code)
        console.log({giftCode})


        // if on another collection, don't do couponNotification
        if (swaggyCollectionHandle !== giftCode.collectionHandle) {
            console.log(`current collection ${swaggyCollectionHandle} is not compatible with gift code collection ${giftCode.collectionHandle}`)
            removeNotification()
            showDescription()
            showAllProducts()
            showPrices()
            enableBuying()
            return giftCode
        }

        customizeStoreForGiftCode(giftCode)


        // console.log({remainingValue})

        let message
        if ('PERCENTAGE' === giftCode.valueType) {
            if (cart.item_count && giftCode.maxProductCount && cart.item_count >= giftCode.maxProductCount) {
                console.log("cart.item_count && cart.item_count >= giftCode.maxProductCount")
                // message = `Yay! You have used your full gift code value. You can go to your <a href="/cart" class="s-underline">cart</a> to remove ${cart.item_count > 1 ? "products" : "the product"} or to check out.`
                disableBuying()
            } else if (cart.item_count && giftCode.maxProductCount  && cart.item_count < giftCode.maxProductCount) {
                message = `You can select ${giftCode.maxProductCount - cart.item_count} additional products in the <a href="/collections/${giftCode.collectionHandle}" class="s-underline">${giftCode.collectionTitle}</a> collection.`
                enableBuying()
            } else if (cart.item_count === 0 && giftCode.maxProductCount  && cart.item_count < giftCode.maxProductCount) {
                enableBuying()
            } else {
                console.log("no maxProductCount")
                showPrices()
                enableBuying()
            }
        } else if ('AMOUNT' === giftCode.valueType) {

            if (giftCode.currency === cart.currency) {
                const originalCouponValue = getOriginalGiftCardValue(giftCode)
                const remainingValue = await getRemainingGiftCodeValue(giftCode, cart)
                discountPrices(remainingValue)
                showPrices()
                enableBuying()
                console.log({remainingValue})
                if (remainingValue === originalCouponValue) {
                    message = `Nice .. You have a ${currencyDisplay(originalCouponValue)} credit in the <a href="/collections/${giftCode.collectionHandle}" class="s-underline">${giftCode.collectionTitle}</a> collection.`
                } else if (remainingValue > 0) {
                    message = `You have ${currencyDisplay(remainingValue)} remaining from your ${currencyDisplay(originalCouponValue)} credit in the <a href="/collections/${giftCode.collectionHandle}" class="s-underline">${giftCode.collectionTitle}</a> collection.`
                } else {
                    message = `Yay! You maximized your ${currencyDisplay(originalCouponValue)} credit. Keep shopping and we will apply it when you are ready to checkout.`
                }
            } else {
                showPrices()
                enableBuying()
                message = "Shop as much as you like, your credit will be shown in your cart and at checkout."

            }
        }

        if (message) {
            showNotification(message)
        } else {
            removeNotification()
        }

        return giftCode


    } catch (e) {
        removeNotification()
        showDescription()
        showAllProducts()
        showPrices()
        enableBuying()
    }
}

function enableBuying() {
    console.log('enableBuying')
    $(PRODUCT_FORM_SUBMIT_BUTTON_SELECTOR).removeAttr('disabled')
}

function showPrices() {
    console.log("showPrices")
    $(SWAGGY_HIDDEN_PRICE_SELECTOR).removeClass("s-hidden")
}

function hidePrices() {
    console.log("hidePrices")
    $(SWAGGY_HIDDEN_PRICE_SELECTOR).addClass("s-hidden")
}

function showDescription() {
    $(SWAGGY_HIDDEN_DESCRIPTION_SELECTOR).removeClass(SWAGGY_HIDE_CLASSES).addClass(SWAGGY_SHOW_CLASSES)
}

function showAllProducts() {
    $(SWAGGY_HIDDEN_PRODUCT_SELECTOR).removeClass([SWAGGY_HIDE_CLASSES]).addClass(SWAGGY_SHOW_CLASSES)
}

function customizeStoreForGiftCode(giftCode) {
    console.log("customizeStoreForGiftCode")
    const storeBehavior = giftCode?.storeBehavior

    // considered showing everything BUT b2b *can* actually shop with a gift code now
    // const swaggyB2B = $(SWAGGY_METADATA_SELECTOR).data('swaggy-b2b')
    // if (swaggyB2B) {
    //     console.log("b2b - show description and all products")
    //     showDescription()
    //     showAllProducts()
    //     return
    // }

    if (storeBehavior?.description) {
        $(SWAGGY_HIDDEN_DESCRIPTION_SELECTOR).html(storeBehavior.description)
    }
    showDescription()


    if (storeBehavior?.showProducts) {
        console.log({storeBehavior})

        const productHandlesToShow = []
        for (const productHandle of storeBehavior.showProducts) {
            productHandlesToShow.push(productHandle)
        }
        $(SWAGGY_HIDDEN_PRODUCT_SELECTOR).each(function () {
            const thisProductHandle = $(this).data("product-handle")
            if (productHandlesToShow.includes(thisProductHandle)) {
                $(this).removeClass(SWAGGY_HIDE_CLASSES).addClass(SWAGGY_SHOW_CLASSES)
            } else {
                $(this).addClass(["s-hidden"])
            }
        });

    } else {
        showAllProducts()
    }

    if (storeBehavior?.showEffects) {
        try {
            window[storeBehavior.showEffects]()
        } catch (e) {
            console.error(`could not find ${storeBehavior.showEffects} effects`)
        }
    }

}

function disableBuying() {
    console.log('disableBuying')
    hidePrices()
    $(PRODUCT_FORM_SUBMIT_BUTTON_SELECTOR).prop('disabled', true)
    $(PRODUCT_FORM_SUBMIT_BUTTON_SELECTOR).text('Selection made')
}

function discountPrices(remainingValue) {
    console.log('discountPrices')
    $(SWAGGY_DISCOUNTED_PRICE_SELECTOR).remove()
    if (remainingValue <= 0) {
        return
    }

    const $priceSpans = $(REGULAR_PRICE_SELECTOR)
    $priceSpans.each(function () {
        const $priceSpan = $(this)
        const text = $priceSpan.text()
        const price = Number(text.substring(text.indexOf("$") + 1, text.indexOf(" USD")))
        const discountedPrice = price - remainingValue
        let discountMessage
        if (discountedPrice > 0) {
            discountMessage = `(Only $${discountedPrice.toFixed(2)} after your credit)`
        } else {
            discountMessage = '(free after your credit)'
        }

        if (discountMessage) {
            const discountMessageHtml = `<p class="swaggy-discounted-price">${discountMessage}</p>`
            $(discountMessageHtml).insertAfter($priceSpan)
        }
    })

}

function getCookieValue(name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
}

async function checkForGiftCode() {
    console.log("checkForGiftCode")
    let code = getCookieValue(SHOPIFY_DISCOUNT_COOKIE_KEY)
    console.log("code (cookie)", code)

    const cart = await getCart()
    // console.log({cart})
    const cartItems = cart.items || []
    // console.log({cartItems})
    if (cartItems.length) {
        const cartLineLevelDiscounts = cartItems[0].line_level_discount_allocations || []
        // console.log({cartLineLevelDiscounts})
        if (cartLineLevelDiscounts.length) {
            const discountApplication = cartLineLevelDiscounts[0].discount_application || null
            // console.log({discountApplication})
            if (discountApplication && discountApplication.title) {
                code = discountApplication.title
                console.log('code (cart)', code)
            }
        }
    }

    // set into sessionStorage if found in cookie or cart
    if (code) {
        sessionStorage.setItem(SHOPIFY_DISCOUNT_COOKIE_KEY, code)
    } else {
        code = sessionStorage.getItem(SHOPIFY_DISCOUNT_COOKIE_KEY)
        console.log('code (sessionStorage)', code)
    }

    // delete if found in none of those methods
    if (!code) {
        console.log("no discount code")
        sessionStorage.removeItem(SHOPIFY_DISCOUNT_COOKIE_KEY);
        removeNotification()
        showDescription()
        showAllProducts()
        showPrices()
        enableBuying()
        return
    }

    await handleGiftCode(code, cart)
}

function b2bBanner() {
    const swaggyB2B = $(SWAGGY_METADATA_SELECTOR).data('swaggy-b2b')
    // console.log('swaggyB2B', swaggyB2B)
    if (swaggyB2B) {
        const companyName = $(SWAGGY_METADATA_SELECTOR).data('swaggy-b2b-company-name')
        const name = $(SWAGGY_METADATA_SELECTOR).data('swaggy-name')
        const message = `${companyName} Admin`
        showNotification(message)
    }

}

function productFormSubmitDOMSubtreeModifiedHandler(event) {
    const $productFormSubmitButton = $(this)
    if ($productFormSubmitButton.attr('disabled')) {
        $(CUSTOMIZE_PRODUCT_BUTTON_SELECTOR).prop('disabled', true)
    } else {
        $(CUSTOMIZE_PRODUCT_BUTTON_SELECTOR).removeAttr('disabled')
    }
}

function productFormSubmitClickHandler(event, options) {
    const $productFormSubmitButton = $(this)
    options = options || {}
    const $customizeProductButton = $(CUSTOMIZE_PRODUCT_BUTTON_SELECTOR)
    if (!$customizeProductButton.length || options.skip_product_personalization) {
        // console.log('no personalization button or user skipped personalization - add product to cart')
        return
    }
    event.preventDefault()

    $customizeProductButton.trigger(event.type)

}

async function createCodeClickHandler(event) {
    event.preventDefault()
    const target = $(event.target)
    const locationId = target.data('locationId')
    const discountCode = target.data('discountCode')
    const spinner = target.find('svg')
    spinner.removeClass('s-hidden')

    try {
        const response = await fetch(SWAGGY_CREATE_CODE_URL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({locationId, discountCode}),
            cache: 'default'
        })
        const newDiscountCodeResponse = await response.json()
        // console.log('newDiscountCode', newDiscountCodeResponse)

    } finally {
        spinner.addClass('s-hidden')
    }

    location.reload()

}


function productFormButtonsDOMNodeInserted(event) {
    const $el = $(event.target)
    if ($el.is(CUSTOMIZE_PRODUCT_BUTTON_SELECTOR)) {
        $el.siblings().not(PRODUCT_FORM_SUBMIT_BUTTON_SELECTOR).addClass('s-hidden')
    }
}

function configureAjaxLogoutAndRedirect() {
    // https://community.shopify.com/c/shopify-discussions/redirect-after-shopify-logout/m-p/1704485
    $('a[href^="/customer_identity/logout"]').on("click", function () {
        const logoutUrl = $(this).attr('href')
        const currentUrl = window.location.pathname
        $.ajax(logoutUrl)
            .done(function () {
                window.location.href = currentUrl
            })
        return false
    })
}

function redirectIfNotAuthorized(coupon) {
    const swaggyCollectionHandle = $(SWAGGY_METADATA_SELECTOR).data('collection-handle')
    const swaggyUseCase = $(SWAGGY_METADATA_SELECTOR).data('swaggy-use-case')


    // console.log({swaggyCollectionHandle, swaggyUseCase, swaggyB2B, coupon})

    // no other use cases currently have the concept of requiring customers to authenticate
    if (swaggyUseCase !== SWAGGY_GIFT_USE_CASE) {
        return
    } else if (swaggyUseCase === SWAGGY_GIFT_USE_CASE && swaggyB2B) { // TODO need to also check that the b2b user's authorized collections include the current one
        return
    } else if (swaggyUseCase === SWAGGY_GIFT_USE_CASE && coupon?.code && swaggyCollectionHandle === coupon?.collectionHandle) {
        return
    }

    const currentUrl = window.location.pathname
    if (currentUrl !== SWAGGY_NOT_AUTHORIZED_PAGE) {
        // console.log('redirect to:', SWAGGY_NOT_AUTHORIZED_PAGE, 'currentUrl:', currentUrl)
        window.location.href = SWAGGY_NOT_AUTHORIZED_PAGE
    }


}

async function checkForGiftCodeOnExternalEvents(e) {
    console.log('checkForGiftCodeOnExternalEvents')
    await wait(500)
    await checkForGiftCode()
}

function storeFeedbackButtonClickHandler(event) {
    event.preventDefault()
    Intercom('showNewMessage', 'Enter store feedback here:\n');
}

function productFeedbackButtonClickHandler(event) {
    event.preventDefault()
    const target = $(event.target)
    const productId = target.data("product-id")
    const productTitle = target.data("product-title")
    const productHandle = target.data("product-handle")
    // console.log('productFeedbackButtonClickHandler', productId, productTitle, productHandle)
    const url = new URL(location)
    const productAdminUrl = `https://${url.hostname}/admin/products/${productId}`
    const productStoreUrl = `https://${url.hostname}/products/${productHandle}`
    const metadata = {productId, productTitle, productAdminUrl, productStoreUrl}
    // console.log({metadata})
    Intercom('trackEvent', 'click-product-feedback', metadata);
    Intercom('showNewMessage', `Enter your feedback on the ${productTitle}:\n`);

}


$(document).ready(async function () {

    configureAjaxLogoutAndRedirect()

    await checkForGiftCode()

    try {
        const cartIconObserver = new MutationObserver(async () => {
            await checkForGiftCode()
        })
        cartIconObserver.observe(document.querySelector(CART_ICON_BUBBLE_SELECTOR), {childList: true})
    } catch (e) {
        console.error("could not observe cart icon")
    }


    // fix for printful Personalize design button being disabled
    try {
        const productFormSubmitButtonObserver = new MutationObserver(productFormSubmitDOMSubtreeModifiedHandler)
        productFormSubmitButtonObserver.observe(document.querySelector(PRODUCT_FORM_SUBMIT_BUTTON_SELECTOR), {childList: true})
    } catch (e) {
        console.error("could not observe printful personalize button")
    }

    $(PRODUCT_FORM_SUBMIT_BUTTON_SELECTOR).on('click', productFormSubmitClickHandler)

    $(PRODUCT_FORM_SUBMIT_BUTTON_SELECTOR).on('addToCartButtonDisabledEvent', checkForGiftCodeOnExternalEvents)

    try {
        const productFormButtonsObserver = new MutationObserver(productFormButtonsDOMNodeInserted)
        productFormButtonsObserver.observe(document.querySelector(PRODUCT_FORM_BUTTONS_SELECTOR), {childList: true})
    } catch (e) {
        console.error("could not observe product form buttons")
    }

    $(SWAGGY_CREATE_CODE_BUTTON_SELECTOR).on('click', createCodeClickHandler)

    $(SWAGGY_STORE_FEEDBACK_BUTTON_SELECTOR).on('click', storeFeedbackButtonClickHandler)
    $(SWAGGY_PRODUCT_FEEDBACK_BUTTON_SELECTOR).on('click', productFeedbackButtonClickHandler)

    window.navigation.addEventListener("navigate", async (event) => {
        console.log('location changed!');
        await checkForGiftCodeOnExternalEvents()
    })


})
